import { render, staticRenderFns } from "./account_setting.vue?vue&type=template&id=0d29dc06&scoped=true"
import script from "./account_setting.vue?vue&type=script&lang=js"
export * from "./account_setting.vue?vue&type=script&lang=js"
import style0 from "./account_setting.vue?vue&type=style&index=0&id=0d29dc06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d29dc06",
  null
  
)

export default component.exports